/**
 * Set coupon input
 */
export const COUPONS_INPUT_SET = 'COUPONS_INPUT_SET';

/**
 * Set coupon codes
 */
export const COUPONS_CODES_SET = 'COUPONS_CODES_SET';

/**
 * Set referral
 */
export const COUPONS_REFERRAL_SET = 'COUPONS_REFERRAL_SET';

/**
 * Check referral
 */
export const COUPONS_REFERRAL_CHECK = 'COUPONS_REFERRAL_CHECK';

/**
 * Referral error
 */
export const COUPONS_REFERRAL_ERROR = 'COUPONS_REFERRAL_ERROR';
